import React from 'react';
import { withStyles } from '@material-ui/styles';
import CloseIcon from '@material-ui/icons/Close';
import HowToRegOutlinedIcon from '@material-ui/icons/HowToRegOutlined';
import { PromptDetails } from '../models/promptsTypeModels.types';
import Tooltip from '@material-ui/core/Tooltip';
import { useStyles, ExaminersTreeButton, EmptyExaminersTreeButton } from './ExaminersTreeButton.styles';

interface ExaminersTreeButtonProps {
  name?: string;
  id?: string;
  domesticCoordinatorId?: string;
  onClick: (param: PromptDetails) => void;
  handleDomesticCoordinator: () => void;
  isRemovingHidden?: boolean;
}

const ETButton: React.FC<ExaminersTreeButtonProps> = (props) => {
  const classes = useStyles();

  const switchButton = () => {
    if (props.name && props.domesticCoordinatorId) {
      props.onClick({
        fullName: props.name,
        examinatorId: props.domesticCoordinatorId,
        type: 'confirmation',
        groupId: '',
        otherText: '',
        typePromp: 'KK',
      });
    }
  };

  const RedTooltip = withStyles({
    tooltip: {
      backgroundColor: '#BC0000',
      fontSize: '1em',
    },
  })(Tooltip);

  return (
    <>
      {!props.name ? (
        <EmptyExaminersTreeButton onClick={props.handleDomesticCoordinator}>
          <HowToRegOutlinedIcon className={classes.howToRegIcon} /> Przypisz Koordynatora Krajowego
        </EmptyExaminersTreeButton>
      ) : (
        <ExaminersTreeButton
          variant="contained"
          endIcon={
            props.isRemovingHidden ? undefined : (
              <RedTooltip title="Usuń" placement="top">
                <CloseIcon onClick={switchButton} className={classes.closeIcon} />
              </RedTooltip>
            )
          }
        >
          Koordynator Krajowy: &nbsp; {props.name}
        </ExaminersTreeButton>
      )}
    </>
  );
};

export default ETButton;
